module.exports = __webpack_public_path__ + "assets/TriangleMidSegmentDetailed.8790c6c98ce52a19932514cd7a719c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TriangleMidSegmentDetailed.png
// module id = 597
// module chunks = 0